module.exports = __webpack_public_path__ + "/fonts/BisnodeSans-Regular.woff";